import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ParachuteBox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M383.5 192c.3-5.3.5-10.6.5-16 0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4.2 10.7.5 16H240v128h-32c-7 0-13.7 1.5-19.7 4.2L68.2 192h28.3c-.3-5.3-.5-10.6-.5-16 0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6 1.5 183.1 9 192 18.9 192h6l140.3 154.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4-14.4-51-57.8-124.3-148.9-156.9C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2h-32V192h111.5z"
  }));
});
ParachuteBox.displayName = 'ParachuteBox';
export var ParachuteBoxDimensions = {
  height: 512,
  width: 512
};